import { render } from "./EditAccountView.vue?vue&type=template&id=67057050"
import script from "./EditAccountView.vue?vue&type=script&lang=js"
export * from "./EditAccountView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__